<riff-header [items]="menu$ | async"></riff-header>
<router-outlet></router-outlet>
<riff-footer></riff-footer>
